// extracted by mini-css-extract-plugin
export default {"error-modal":"DangerAlert_error-modal__zTpJR","error-text":"DangerAlert_error-text__0BUaj"};